/* global $ */

//Change HEADER on scroll down
$(function () {
  var header = $('#header_home');

  var promo = $('.hero__promo');

  $(window).scroll(function () {
    var scroll = $(window).scrollTop();

    if (scroll >= 70) {
      header.removeClass('clearHeader').addClass("whiteHeader");
      promo.removeClass('hide-promo').addClass("show-promo");
      $('.announcement-bar').addClass('hide-bar');

    } else {
      header.removeClass("whiteHeader").addClass('clearHeader');
      $('.announcement-bar').removeClass('hide-bar');
      promo.removeClass('show-promo').addClass("hide-promo");

    }
  });
});


//Change hero promo on scroll
$(function () {


  var promo = $('.hero__promo');

  $(window).scroll(function () {
    var scroll = $(window).scrollTop();

    if (scroll >= 120) {

      promo.removeClass('hide-promo').addClass("show-promo");


    } else {


      promo.removeClass('show-promo').addClass("hide-promo");

    }
  });
});


//mobile menu - slide out

$('.moveup').click(function () {
  $('.mobile-nav').addClass('menu-mobile-animate');
});

$('.moveout').click(function () {
  $('.mobile-nav').removeClass('menu-mobile-animate');
});


//Testimonials quote carousel
$('.owl-1').owlCarousel({
  items: 1,
  autoplay: true,
  autoplaySpeed: 4900,
  animateOut: 'fadeOut',
  dots: true,
  autoHeight: true,
  autoplayTimeout: 4100,
  autoplayHoverPause: true,
  loop: true,
  nav: false,
  lazyLoad: true,
  margin: 20,
  responsive: {





  }
});


//hero slider
$('#owl-hero').owlCarousel({
  center: true,
  items: 1,
  autoplay: true,
  autoplaySpeed: 4900,
  animateOut: 'fadeOut',
  dots: false,
stagePadding: 0,
  autoplayTimeout: 4100,
  autoplayHoverPause: false,
  loop: true,
  touchDrag: true,
  mouseDrag: true,
  nav: false,
  lazyLoad: true,
  margin: 20,
  responsive: {

  }
});


//scroll scrollReveal - wrap individual character with <span> for animations


$(document).ready(function () {


  //Init ScrollMagic
  var controller = new ScrollMagic.Controller();

  $('.under').each(function () {

    $('<span class="anime_under"></span>').appendTo(this);
    var header = $('.anime_under');

    // build a scene
    var parallaxTld6 = new TimelineMax({ delay: 0.7 });
    parallaxTld6.staggerTo(header, 2, { x: 1, width: "100%" });
    var ourScene = new ScrollMagic.Scene({
      triggerElement: this,
      triggerHook: .95
    })
      .setTween(parallaxTld6)
      .addTo(controller);

  });


  $('.under_green').each(function () {

    $('<span class="anime_under"></span>').appendTo(this);
    var header = $('.anime_under');

    // build a scene
    var parallaxTld6 = new TimelineMax({ delay: 0.7 });
    parallaxTld6.staggerTo(header, 2, { x: 1, width: "100%" });
    var ourScene = new ScrollMagic.Scene({
      triggerElement: this,
      triggerHook: .95
    })
      .setTween(parallaxTld6)
      .addTo(controller);

  });


   $('.under_pink').each(function () {

    $('<span class="anime_under"></span>').appendTo(this);
    var header = $('.anime_under');

    // build a scene
    var parallaxTld6 = new TimelineMax({ delay: 0.7 });
    parallaxTld6.staggerTo(header, 2, { x: 1, width: "100%" });
    var ourScene = new ScrollMagic.Scene({
      triggerElement: this,
      triggerHook: .95
    })
      .setTween(parallaxTld6)
      .addTo(controller);

  });

  // reveal stories



  $(".animate").html(function (index, html) {
    var decodedHtml = $("<textarea/>").html(html).text(); // Decode HTML entities
    return decodedHtml.replace(/\S/g, '<span>$&</span>');
  });

  var fooReveal4 = {
    origin: 'bottom',
    delay: 80,
    distance: '100px',
    viewFactor: .6,
    opacity: null,
    duration: 2300,
    reset: true,
    easing: 'cubic-bezier(0.6, 0.2, 0.1, 1)'
  };


  var fooReveal = {
    origin: 'top',
    delay: 90,
    distance: '30px',
    viewFactor: .8,
    duration: 1400,
    opacity: 0,
    reset: true,
    easing: 'cubic-bezier(0.6, 0.2, 0.1, 1)'
  };

  var fooReveal2 = {
    origin: 'bottom',
    delay: 80,
    distance: '30px',
    viewFactor: .8,
    opacity: 0,
    duration: 1400,
    reset: true,
    easing: 'cubic-bezier(0.6, 0.2, 0.1, 1)'
  };

  var fooReveal3 = {
    delay: 160,
    viewFactor: 1,
    duration: 1800,
    reset: true
  };


  window.sr = ScrollReveal();

  sr.reveal('.animate span:nth-child(even)', fooReveal);
  sr.reveal('.animate span:nth-child(odd)', fooReveal2);
  sr.reveal('.collection__feature--description', fooReveal3);


});

//move content on product pages
$(init);

function init() {

  //Move product tag line somewhere else
  $('.product__tagline').append($('.product__details-container>h2'));

  //move ingredients into popup container
  $('.popup-content').append($('.all_ingredients'));

  //move ingredients into popup container


}

$("<a id='open-pop'>View full ingredient list</a>").insertAfter(".key_ingredients");


//faqs accordion
if (jQuery(".toggle .toggle-title").hasClass('active')) {
  jQuery(".toggle .toggle-title.active").closest('.toggle').find('.toggle-inner').show();
}
jQuery(".toggle .toggle-title").click(function () {
  if (jQuery(this).hasClass('active')) {
    jQuery(this).removeClass("active").closest('.toggle').find('.toggle-inner').slideUp(0);
  }
  else {
    jQuery(this).addClass("active").closest('.toggle').find('.toggle-inner').slideDown(0);
  }
});



//ingredient pop up

$("#open-pop").on("click", function () {
  $(".popup-overlay, #pop-mel-city").addClass("active");
});

//removes the "active" class to .popup and .popup-content when the "Close" button is clicked
$(".close, .popup-overlay").on("click", function () {
  $(".popup-overlay, .popup-content").removeClass("active");
});

//anchor to page position but allow some paddding above to compensate the fixed navigation

(function ($, window) {
  var adjustAnchor = function () {

    var $anchor = $(':target'),
      fixedElementHeight = 107;

    if ($anchor.length > 0) {

      $('html, body')
        .stop()
        .animate({
          scrollTop: $anchor.offset().top - fixedElementHeight
        }, 107);

    }

  };

  $(window).on('hashchange load', function () {
    adjustAnchor();
  });

})(jQuery, window);


/* LOAD MORE DISABLED AS REQUESTED
Load more content with jQuery - May 21, 2013
(c) 2013 @ElmahdiMahmoud

$(function () {
  $(".ajax-item").slice(0, 8).show();
  $("#loadMore").on('click', function (e) {
      e.preventDefault();
      $(".ajax-item:hidden").slice(0, 4).slideDown();
      if ($(".ajax-item:hidden").length == 0) {
          $("#load").fadeOut();
      }
      $('html,body').animate({
          scrollTop: $(this).offset().top
      }, 1500);
  });
});
*/

//30% OFF Sale September 8th to 11th - then extended to the 12th

// call on moment.js for timezone
// change value to 2019-09-12 later on


var c_val = "Rapid Candy Oil";
 //var c_val = 'Candy Oil';
$('.bundle_container').find('select').change(function(){

 var id = $(this).closest('.bundle_container').attr('id');
                if($("#"+id).find('option[value="Rapid Candy Oil"]:selected').length > 2 ){
                alert('Sorry, only a maximum of 2' + ' ' + c_val + ' ' + 'bottles per bundle');
                    $('.message').show();
                $(this).val($(this).find("option:first").val());


              }

 else {
   $('.message').hide();
 }
          });






$(document).on('load',function () {
    $("#insta-feed").prepend("<p>Para 4</p>");
});


// add to cart from home and collection pages
function AddToBagGrid($id) {
  var quantity = '1';//add quantity selector here
  var id= $id;// variant selector here
  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    dataType: 'json',
    data: {id:id,quantity:quantity},
    success: function(){
      $(".js-drawer-open-button-right").trigger("click");
    }
  });
};
